// Grupos da biblioteca do nó "Enviar mídia": fotos com o mesmo nome e um
// número no fim (RAPTOR1, RAPTOR2; S12-1, S12-2) viram o grupo do modelo
// (RAPTOR, S12), que a IA manda de uma vez. Mesma regra do backend
// (Agno::MediaGroups): "S12" sozinho não é cortado.
export const groupName = label => {
  const text = (label || '').trim();
  const match =
    text.match(/^(.*?\S)[\s_-]+\d+$/) || text.match(/^(.*\p{L}{2})\d+$/u);
  return (match ? match[1] : text).trim();
};

const hasNumber = label => groupName(label) !== (label || '').trim();

// Modelos já usados na biblioteca (só nomes com número no fim), na ordem.
export const modelNames = items => {
  const seen = new Map();
  items.forEach(item => {
    if (!hasNumber(item.label)) return;
    const name = groupName(item.label);
    if (!seen.has(name.toUpperCase())) seen.set(name.toUpperCase(), name);
  });
  return [...seen.values()];
};

// Próximo nome livre do modelo: DOT → DOT4 se já há DOT1..DOT3. Modelo que
// termina em número leva hífen (G15 → G15-1), senão o número grudaria nele.
export const nextLabel = (model, items) => {
  const name = model.trim();
  const key = name.toUpperCase();
  const max = items.reduce((acc, item) => {
    if (!hasNumber(item.label)) return acc;
    if (groupName(item.label).toUpperCase() !== key) return acc;
    return Math.max(acc, Number(item.label.trim().match(/(\d+)$/)[1]));
  }, 0);
  const join = /\p{L}{2}$/u.test(name) ? '' : '-';
  return `${name}${join}${max + 1}`;
};

// Renomeia as mídias (ids) para o modelo, numerando depois das que já existem.
export const assignModel = (items, ids, model) => {
  const moving = new Set(ids);
  let others = items.filter(item => !moving.has(item.id));
  const renamed = new Map();
  ids.forEach(id => {
    const label = nextLabel(model, others);
    renamed.set(id, label);
    others = [...others, { id, label }];
  });
  return items.map(item =>
    renamed.has(item.id) ? { ...item, label: renamed.get(item.id) } : item
  );
};

// [{ name, items }] na ordem da biblioteca. Grupo de uma mídia só vira
// item avulso (name: null).
export const groupItems = items => {
  const byKey = new Map();
  items.forEach(item => {
    const key = groupName(item.label).toUpperCase();
    if (!byKey.has(key)) byKey.set(key, []);
    byKey.get(key).push(item);
  });
  const sections = [];
  const loose = [];
  byKey.forEach((list, key) => {
    if (key && list.length > 1) {
      sections.push({ name: groupName(list[0].label), items: list });
    } else {
      loose.push(...list);
    }
  });
  if (loose.length) sections.push({ name: null, items: loose });
  return sections;
};
